module.exports = __webpack_public_path__ + "img/banner2_4_zh.9b66a8f4.png";